import type {MithraMaterializedApi} from "~/services/MithraMaterializedApi.ts";
import type {BagStore} from "~/stores/BagStore.tsx";
import {makeAutoObservable} from "mobx";
import type ProfileStore from "../../../stores/ProfileStore";
import {SCPageController} from "./controllers/SCPageController.ts";
import type AuthStore from "../../../authentication/AuthStore.tsx";

export class SpendConcentrationStore {
    readonly sCPageController: SCPageController;

    // noinspection JSUnusedLocalSymbols
    constructor(
        private auth: AuthStore,
        private api: MithraMaterializedApi,
        private bagStore: BagStore,
        private profileStore: ProfileStore,
    ) {
        this.sCPageController = new SCPageController(api, auth, bagStore, profileStore);
        makeAutoObservable(this);
    }

    // get groupedData(): BarDataPoint[] | undefined {
    //     if (!this._spendConcentrationRequestManager.result) return undefined;
    //     const currencySymbol = this.profileStore.currencySymbol;
    //     const level = this.sCPageController.filterController.selectedLevel + (this.sCPageController.filterController.canSelectLevelDeeper ? 1 : 0);
    //     return this._spendConcentrationRequestManager.result[1].data
    //         .filter(d => {
    //             if (d.level !== level) return false;
    //             // Check if the parent levels match the current selection
    //             for (let i = 0; i < level - 1; i++) {
    //                 const category = d[`l${i + 1}`] as string;
    //                 if (this.sCPageController.filterController.selectedCategory[i] !== category) {
    //                     return false;
    //                 }
    //             }
    //             return true;
    //         })
    //         .map<BarDataPoint>(d => {
    //             const category = d[`l${level}`] as string;
    //             const categoryLabel = category === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : category;
    //             const valueLabel = `${Math.round(d.top_n_spend_percentage * 100) + '%'}`
    //                 + `  |  ${toCurrency(currencySymbol, d.total_spend)}`
    //                 + `  |  ${d.distinct_suppliers} suppliers`;
    //             return {value: d.top_n_spend_percentage, valueLabel, category, categoryLabel};
    //         })
    // }
}
